import React from 'react';
import merge from 'classnames';

type Props = React.HTMLAttributes<HTMLSpanElement> & {
  className?: string;
};

export const SvgIconContainer = (props: Props) => {
  const { className, children, ...restProps } = props;

  return (
    <span data-testid="svg-icon-container" {...restProps} className={merge('svg_icon', className)}>
      {children}
    </span>
  );
};
